import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the area managers of the countries (50-api/party.md, ADR-246): every country at once, a few hundred.

const countries = api.party["country-area-managers"];

export type CountryAreaManager = InferResponseType<typeof countries.$get, 200>[number];

const keys = { all: ["country-area-managers"] as const };

export const countryAreaManagerQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(countries.$get({ query: {} }, { init: { signal } })),
    }),
};
